import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { RegionalTax } from "@/app/services/generated/regionaltaxService";
import { regionalTaxService } from "@/app/services/generated/regionaltaxService";

export interface IHasRegionalTaxesCache {
  regionalTaxes: RegionalTaxesCache;
}

// Singleton cache store
const regionalTaxesCacheStore = new EntityCacheStore<RegionalTax>(
  EnumCacheEntityType.regionalTax,
  async () => regionalTaxService.getAllRegionalTaxes()
);

// Ephemeral reader
export default class RegionalTaxesCache extends EntityWithGuidKeyCache<RegionalTax> {
  constructor() {
    super(regionalTaxesCacheStore, (x) => x.id);
  }
}
